import React, { useMemo } from 'react';

import { useLocalSearchParams } from 'expo-router';
import { MenuHeaderNavigation } from 'features/menu/components/menu-header-navigation';
import { MenuNavigationTabs } from 'features/menu/components/menu-navigation-tabs/menu-navigation-tabs';
import { MenuSection } from 'features/menu/components/menu-section/menu-section';
import { useTargetItemIds } from 'features/menu/hooks/use-target-item-ids';
import { pinTargetItems } from 'features/menu/utils/pin-target-items';
import { View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { AppTakeoverMenuSectionTransition } from 'components/app-takeover/app-takeover-menu-section-transition';
import { useAppTakeoverMenuSection } from 'components/app-takeover/use-app-takeover';
import { FullWidthAutoHeightImage } from 'components/picture';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';

// NEW one menu
export const MenuSectionPage = () => {
  const { mainMenu } = useUnifiedMenuContext();
  const { id } = useLocalSearchParams<{ id: string }>();
  const targetItemIds = useTargetItemIds();

  const { title, options } = useMemo(() => {
    const section = mainMenu?.find(section => section.id === id);
    const options = pinTargetItems(section?.children ?? [], targetItemIds);
    return { title: section?.name ?? '', options };
  }, [id, mainMenu, targetItemIds]);

  const {
    headerBackgroundColor,
    headerBackgroundImage,
    itemBackgroundColor: takeoverBg,
    footerImage: takeoverFooterImage,
    footerImageOffset: takeoverFooterImageOffset,
  } = useAppTakeoverMenuSection(id);

  const headerBackgroundColorOverride = headerBackgroundImage
    ? 'transparent'
    : headerBackgroundColor
    ? headerBackgroundColor
    : undefined;

  const tabs = (
    <>
      {/* key is used to force re-render and display Section name after reloading page, 
          there is a memo messing up prop comparison */}
      <MenuHeaderNavigation
        title={title}
        key={title}
        headerBackgroundColorOverride={headerBackgroundColorOverride}
      />
      <MenuNavigationTabs
        mainMenu={mainMenu}
        headerBackgroundColorOverride={headerBackgroundColorOverride}
      />
    </>
  );

  const takeoverFooterSpacer = takeoverFooterImageOffset && (
    <View style={{ width: '100%', height: takeoverFooterImageOffset }}></View>
  );

  return (
    <SafeAreaView edges={['bottom']} style={{ flex: 1, backgroundColor: takeoverBg }}>
      <AppTakeoverMenuSectionTransition sectionId={id} />
      {headerBackgroundImage ? (
        <View>
          <FullWidthAutoHeightImage source={headerBackgroundImage} />
          <View style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>{tabs}</View>
        </View>
      ) : (
        tabs
      )}
      <MenuSection data={options} footerSpacer={takeoverFooterSpacer} />
      {takeoverFooterImage && (
        <View pointerEvents="none" style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
          <FullWidthAutoHeightImage source={takeoverFooterImage} />
        </View>
      )}
    </SafeAreaView>
  );
};
